import React from 'react';
import { useSelector } from 'react-redux';
import { ViewFrame, ListTable } from '../../components';
import { useActionDispatcher, useTitle } from '../../hooks';
import { getOrderListRequest, setOrderListDirty } from '../../store/modules/orders/actions';
import { selectOrderList } from '../../store/modules/orders/selectors';

const title = 'Orders';

const OrderList = () => {
  useTitle(title);

  const { loading, data, dirty } = useSelector(selectOrderList);

  const getList = useActionDispatcher(getOrderListRequest);
  const setDirty = useActionDispatcher(setOrderListDirty);

  return (
    <ViewFrame title={title}>
      <ListTable
        columns={[
          {
            id: 'title',
            Header: 'Title',
          },
          {
            id: 'ref.user.full_name_first_last',
            Header: 'User',
          },
          {
            id: 'ref.project.title',
            Header: 'Project',
          },
          {
            id: 'ref.status.description',
            Header: 'Status',
          },
          {
            id: 'ref.created_age',
            Header: 'Created',
          },
        ]}
        loading={loading}
        data={data}
        fetch={getList}
        dirty={Boolean(dirty)}
        setDirty={setDirty}
      />
    </ViewFrame>
  );
};

export default OrderList;
